import { Heading } from "@sphtech/sph-web-ui/elements/Heading";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type ParagraphProps = {
  children: ReactNode;
  id?: string;
  sourceId?: string;
  testid?: string;
  className?: string;
  isMobile?: boolean;
};

export default function Paragraph({
  id,
  testid,
  children,
  className,
  isMobile = false,
}: ParagraphProps) {
  const defaultClass = isMobile
    ? undefined
    : twMerge(
        "font-primary-light text-text-body text-2md mb-4 font-bold",
        className,
      );
  return (
    <p
      data-testid={testid}
      className={defaultClass}
      {...(id && { "data-beyondwords-marker": id })}
    >
      {children}
    </p>
  );
}

export function StandFirst({ children, className }: ParagraphProps) {
  return (
    <Heading
      className={twMerge(
        "text-text-muted font-secondary font-bold leading-[110%] text-md lg:text-xl",
        className,
      )}
      Element="h6"
    >
      {children}
    </Heading>
  );
}
